import { DisplayPosition } from '@/type/display-position';
// import { CnCheckboxGroup, componentMap as formComponentMap } from '@cainiaofe/cn-ui-m';
import { condition, handleSelectDataSource, handleSelectRequestConfig, } from '../../util/util';
import { getDataOriginSetterSnippet, getDirectionSetterSnippet, getStaticDataSourceSnippet, } from '../setter-snippet';
import isPlainObject from 'lodash/isPlainObject';
export default {
    position: [
        DisplayPosition.form,
        DisplayPosition.formDialog,
        DisplayPosition.filter,
        DisplayPosition.cnArrayTable,
    ],
    title: '复选框',
    componentName: 'CnCheckboxGroup',
    getFormItemDefaultProps: () => {
        return {
            placeholder: '请选择',
        };
    },
    getDefaultProps: () => {
        return {
            dataOrigin: 'static',
            dataSource: [
                {
                    label: '选项一',
                    value: '选项一',
                },
                {
                    label: '选项二',
                    value: '选项二',
                },
            ],
        };
    },
    getPrototypeList: (position) => {
        return [
            getDataOriginSetterSnippet({
                display: 'inline',
            }),
            // getRequestConfigSetterSnippet({
            //   condition:(prop)=> {
            //     return condition(prop, 'CnCheckboxGroup', 'componentName') && prop?.parent?.getPropValue?.('dataOrigin') === 'request';
            //   },
            // },{
            //   position
            // }),
            {
                name: 'dataSource',
                title: '编辑静态数据',
                display: 'plain',
                tip: '编辑静态展示数据',
                setter: getStaticDataSourceSnippet(),
                condition(prop) {
                    return (condition(prop, 'CnCheckboxGroup', 'componentName') &&
                        prop?.parent?.getPropValue?.('dataOrigin') !== 'request');
                },
            },
            getDirectionSetterSnippet(),
        ];
    },
    formItemBeforeHandler: (formItem, config) => {
        const { isDesign, urlParams, formValue, state } = config;
        const tempProps = formItem?.['x-component-props'];
        if (isPlainObject(tempProps)) {
            const { extra } = tempProps;
            const { direction } = extra || {};
            if (direction) {
                tempProps.direction = direction;
            }
        }
        handleSelectRequestConfig({
            componentProps: formItem?.['x-component-props'],
            isDesign,
            urlParamsDataSource: urlParams,
            recordDataSource: formValue,
            state,
        });
        handleSelectDataSource({
            componentProps: formItem?.['x-component-props'],
            state,
        });
    },
};
